import {useApiariesStore} from "entities/apiaries";
import {CreateFirstApiary} from "widgets/createFirstApiary";
import {Dashboard} from "widgets/dashboard";

export const HomePage = () => {
    const apiaries = useApiariesStore(s => s.apiaries)
    return (
       <>
           {
               apiaries.length > 0 ? <Dashboard/> : <CreateFirstApiary/>
           }
       </>
  )
}
